import { format } from 'date-fns';

import type { Locale } from 'date-fns';

function formatTime(dateString: Date | string, { locale }: { locale?: Locale }): string {
  return format(dateString, 'HH:mm', { locale });
}

export { formatTime };
